import { useEffect } from 'react';
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { FiUserPlus, FiUsers } from 'react-icons/fi';

const ChoiceStep = ({ stepKey, updateStepData, getStepData }) => {
    const stepData = getStepData(stepKey);

    useEffect(() => {
        if (stepData) {
            updateStepData(stepKey, stepData);
        }
    }, []);

    return (
        <div className="flex flex-col space-y-8 items-center">
            <div className="flex flex-col items-center space-y-3">
                <h1 className="font-semibold text-3xl text-center">Set up your new account</h1>
                <p className="text-center text-muted-foreground">Are you creating a new organization or joining an existing one?</p>
            </div>
            <RadioGroup
                value={stepData}
                onValueChange={(value) => updateStepData(stepKey, value)}
                className="w-full max-w-lg mx-auto flex flex-col space-y-3"
            >
                <label className={`flex items-center space-x-6 p-6 border rounded-lg cursor-pointer ${stepData === 'create' ? 'scale-105 border-violet-500 active:scale-[1.04]' : 'scale-100 border-neutral-700 hover:scale-[1.01] active:scale-[0.99]'} transform transition-all duration-200`}>
                    <RadioGroupItem value="create" id="r1" />
                    <Label htmlFor="r1" className="cursor-pointer">
                        <h4 className="font-semibold mb-1">Create a new organization</h4>
                        <p className="text-xs text-muted-foreground">Start fresh with a new workspace for your team</p>
                    </Label>
                </label>
                <label className={`flex items-center space-x-6 p-6 border rounded-lg cursor-pointer ${stepData === 'join' ? 'scale-105 border-violet-500 active:scale-[1.04]' : 'scale-100 border-neutral-700 hover:scale-[1.01] active:scale-[0.99]'} transform transition-all duration-200`}>
                    <RadioGroupItem value="join" id="r2" />
                    <Label htmlFor="r2" className="cursor-pointer">
                        <h4 className="font-semibold mb-1">Join an existing organization</h4>
                        <p className="text-xs text-muted-foreground">If your team is already using StatusBot, request an invite</p>
                    </Label>
                </label>
            </RadioGroup>
        </div>
    );
};

export default ChoiceStep; 